import { NotifyProperty, nameof, Bindable } from "bindable-data";
import { AuthorizedViaDto } from "by/gamefactory/cityversetycoon/networking/data/responses/user/AuthorizedViaDto";
import { BuildingRightsType } from "by/gamefactory/cityversetycoon/networking/data/responses/user/BuildingRightsType";
import { PlayerDto } from "by/gamefactory/cityversetycoon/networking/data/responses/user/PlayerDto";
import { IBuildingModel } from "../../../common/models/Building/IBuildingModel";
import { IPlayerModel } from "../../../common/models/IPlayerModel";

export class PlayerModelFromNewsForRenter extends Bindable implements IPlayerModel {
    public readonly coins: NotifyProperty<number>;
    public readonly tokens: NotifyProperty<string>;
    public readonly rolls: NotifyProperty<number>;
    public readonly shields: NotifyProperty<number>;
    public readonly buildings: NotifyProperty<Array<IBuildingModel>>;
    public readonly hasBuildingFixes: NotifyProperty<boolean>;

    public readonly level: NotifyProperty<number>;
    public readonly nextLevel: NotifyProperty<number>;
    public readonly authorizedVia: NotifyProperty<AuthorizedViaDto>;

    public get isAuthorized(): boolean {
        return true;
    }

    public get openedPiggyBank(): boolean {
        throw new Error("Method not implemented.");
    }

    public readonly upgradePointsBalance: NotifyProperty<number>;
    public readonly requiredPointsBalance: NotifyProperty<number>;
    public readonly buildingRights: NotifyProperty<BuildingRightsType>;
    public readonly lastLeaderboardPlace: NotifyProperty<number>;

    public constructor() {
        super();
        this.coins = new NotifyProperty<number>(this, nameof(this, "coins"), 0);
        this.tokens = new NotifyProperty<string>(this, nameof(this, "tokens"), undefined);
        this.rolls = new NotifyProperty<number>(this, nameof(this, "rolls"), 1);
        this.shields = new NotifyProperty<number>(this, nameof(this, "shields"), 0);
        this.buildings = new NotifyProperty<Array<IBuildingModel>>(this, nameof(this, "buildings"), []);
        this.hasBuildingFixes = new NotifyProperty<boolean>(this, nameof(this, "hasBuildingFixes"), false);
        this.level = new NotifyProperty<number>(this, nameof(this, "level"), 0);
        this.nextLevel = new NotifyProperty<number>(this, nameof(this, "nextLevel"), 0);
        this.authorizedVia = new NotifyProperty<AuthorizedViaDto>(this, nameof(this, "authorizedVia"), undefined);
        this.upgradePointsBalance = new NotifyProperty<number>(this, nameof(this, "upgradePointsBalance"), 0);
        this.requiredPointsBalance = new NotifyProperty<number>(this, nameof(this, "requiredPointsBalance"), 0);
        this.buildingRights = new NotifyProperty<BuildingRightsType>(this, nameof(this, "buildingRights"), BuildingRightsType.RENTER);
        this.lastLeaderboardPlace = new NotifyProperty<number>(this, nameof(this, "lastLeaderboardPlace"), 0);
    }

    public addCoins(coinsValue: number): void {
        throw new Error("Method not implemented.");
    }

    public addTokens(tokensValue: string): void {
        throw new Error("Method not implemented.");
    }

    public addRolls(rollsValue: number): void {
        throw new Error("Method not implemented.");
    }

    public subtractCoins(coinsValue: number): void {
        throw new Error("Method not implemented.");
    }

    public subtractTokens(tokensValue: string): void {
        throw new Error("Method not implemented.");
    }

    public subtractShields(value: number): void {
        throw new Error("Method not implemented.");
    }

    public subtractRolls(): void {
        throw new Error("Method not implemented.");
    }

    public addShields(shieldsValue: number): void {
        throw new Error("Method not implemented.");
    }

    public updateValuesFromClaim(dto: PlayerDto): void {
        throw new Error("Method not implemented.");
    }

    public updateValuesFromUpgrade(dto: PlayerDto): void {
        throw new Error("Method not implemented.");
    }

    public checkAndUpdateBuildingHasFixes(): void {
        throw new Error("Method not implemented.");
    }

    public async loadBuildings(): Promise<void> {
        throw new Error("Method not implemented.");
    }

    public async loadPlayerData(): Promise<void> {
        throw new Error("Method not implemented.");
    }
}